import { useBreadcrumb } from "features/breadcrumbs";
import Container from "components/Container";
import PageHeader from "components/Page/PageHeader/index";
import { Flex, Box } from "@chakra-ui/react";
import { BsPlusLg } from "react-icons/bs";
import CollapsePlanejamento from "./components/CollapsePlanejamento";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import usePrevisaoOrcamentariaDetalhe from "core/features/previsao-orcamentaria/hooks/usePrevisaoOrcamentariaDetalhe";
import { useLoading } from "ui/components/GlobalLoading";
import { showConfirm } from "infra/helpers/alerta";
import { PlanejamentoOrcamentarioDetalheItemResponse } from "core/features/previsao-orcamentaria/typings";
import useDeleteCategoriaPrevisaoOrcamentaria from "core/features/previsao-orcamentaria/hooks/useDeleteCategporiaPrevisaoOrcamentaria ";
import ModalEditarMesLancamento from "./components/ModalEditarMesLancamento";
import ModalImportarPlanilha from "./components/ModalImportarPlanilha";
import ModalLancamentoPrevisao from "ui/components/PrevisaoOrcamentaria/ModalLancamentoPrevisaoOrcamentaria";
import FiltroPeriodo from "ui/components/PrevisaoOrcamentaria/FiltroPeriodo";
import { FiltroPrevisaoOrcamentaria } from "core/features/previsao-orcamentaria/typings";
import { MdCloudUpload } from "react-icons/md";
import colors from "resources/theme/colors";

export default function CriarPrevisaoOrcamentaria() {
  const { id } = useParams() as { id: string };

  const [filtro, setFiltro] = useState<FiltroPrevisaoOrcamentaria>({
    mes: undefined,
    media: undefined,
  });

  const { data, isLoading, isFetching, refetch } =
    usePrevisaoOrcamentariaDetalhe(id, { mes: filtro?.mes });

  useBreadcrumb([
    { name: "Financeiro" },
    {
      name: "Previsão Orçamentária",
      url: "/financeiro/previsao-orcamentaria",
    },
    {
      name: data ? `${data.nome}` : "Editar Previsão",
      url: `/financeiro/previsao-orcamentaria/${id}`,
    },
  ]);

  const [isOpenModalLancamento, setIsOpenModalLancamento] = useState(false);
  const [isOpenModalImportar, setIsOpenModalImportar] = useState(false);

  const [editItem, setEditItem] = useState<
    PlanejamentoOrcamentarioDetalheItemResponse | undefined
  >();

  const [editItemMes, setEditItemMes] = useState<
    PlanejamentoOrcamentarioDetalheItemResponse | undefined
  >();

  const { mutate: handleDeleteCategoria, isLoading: isLoadingDelete } =
    useDeleteCategoriaPrevisaoOrcamentaria();

  const handleDelete = async (categoriaId: string) => {
    const { isConfirmed } = await showConfirm();
    if (isConfirmed) {
      handleDeleteCategoria(
        { categoriaId, id, mes: filtro?.mes },
        { onSuccess: () => refetch() }
      );
    }
  };

  useEffect(() => {
    if (editItem) {
      setIsOpenModalLancamento(true);
    }
  }, [editItem]);

  useEffect(() => {
    if (!isOpenModalLancamento) {
      setEditItem(undefined);
    }
  }, [isOpenModalLancamento]);

  const onEditItem = (item: PlanejamentoOrcamentarioDetalheItemResponse) => {
    if (filtro?.mes) {
      setEditItemMes(item);
    } else {
      setEditItem(item);
    }
  };

  const onChangeFiltro = (filtro: Partial<FiltroPrevisaoOrcamentaria>) => {
    setFiltro((state) => ({ ...state, ...filtro }));
  };

  useLoading(isLoading || isFetching || isLoadingDelete);
  return (
    <>
      <Container>
        <PageHeader
          title={data ? `${data.nome}` : "Editar Previsão"}
          titleButton="Adicionar lançamento"
          buttonProps={{
            leftIcon: <BsPlusLg />,
            iconSpacing: 0,
          }}
          onClick={() => setIsOpenModalLancamento(true)}
          extraButtonTitle="Importar"
          extraButtonProps={{
            leftIcon: <MdCloudUpload color={colors.primary} fontSize={20} />,
            iconSpacing: 0,
          }}
          extraButtonOnClick={() => setIsOpenModalImportar(true)}
        />
        <Box>
          <FiltroPeriodo filtro={filtro} onChangeFiltro={onChangeFiltro} />

          <Flex rowGap="20px" columnGap="60px" flexWrap="wrap">
            {data?.receitas.map((item) => (
              <Flex key={item.id} flex={1} minW="400px">
                <CollapsePlanejamento
                  onEdit={onEditItem}
                  handleDelete={handleDelete}
                  item={item}
                />
              </Flex>
            ))}

            {data?.despesas.map((item) => (
              <Flex key={item.id} flex={1} minW="400px">
                <CollapsePlanejamento
                  onEdit={onEditItem}
                  handleDelete={handleDelete}
                  item={item}
                />
              </Flex>
            ))}
          </Flex>
        </Box>
      </Container>
      <ModalLancamentoPrevisao
        data={editItem}
        dataInicioPrevisao={data?.dataInicio}
        onClose={() => setIsOpenModalLancamento(false)}
        visible={isOpenModalLancamento}
        previsaoId={id}
        refetch={refetch}
      />

      <ModalEditarMesLancamento
        mes={filtro?.mes}
        previsaoId={id}
        refetch={refetch}
        data={editItemMes}
        onClose={() => setEditItemMes(undefined)}
        visible={!!editItemMes}
      />

      <ModalImportarPlanilha
        previsaoId={id}
        refetch={refetch}
        onClose={() => setIsOpenModalImportar(false)}
        visible={isOpenModalImportar}
      />
    </>
  );
}
